import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamMemberRow } from "./data-table-team-members-columns";

export default function DataTableCellMemberStatus({
  member,
}: {
  member: TeamMemberRow;
}) {
  const { t, i18n } = useTranslation();

  if (member.kind === "invitation") {
    return (
      <Badge variant="secondary">
        {t("components.dataTableTeamMembers.status.pendingInvitation")}
      </Badge>
    );
  }

  if (member.priceId) {
    const scheduledUnassignAt = member.user?.scheduledUnassignAt;
    if (scheduledUnassignAt) {
      const formattedDate = new Intl.DateTimeFormat(i18n.language, {
        day: "numeric",
        month: "short",
        year: "numeric",
      }).format(new Date(scheduledUnassignAt));
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <Badge variant="destructive" className="cursor-help">
              {t("components.dataTableTeamMembers.status.scheduledUnassign", {
                date: formattedDate,
              })}
            </Badge>
          </TooltipTrigger>
          <TooltipContent>
            <p>
              {t("components.dataTableTeamMembers.status.licensed")} —{" "}
              {t("components.dataTableTeamMembers.status.scheduledUnassign", {
                date: formattedDate,
              })}
            </p>
          </TooltipContent>
        </Tooltip>
      );
    }
    return (
      <Badge variant="success">
        {t("components.dataTableTeamMembers.status.licensed")}
      </Badge>
    );
  }

  return (
    <Badge variant="outline">
      {t("components.dataTableTeamMembers.status.noLicense")}
    </Badge>
  );
}
